<template lang="pug">
	.recommend-products
		.collections
			a.collection(v-for="(collection, i) in collections", :key="i", v-if="checkId(collection.node.id)", :href="'https://ceretenutrition.com/collections/' + collection.node.handle", target="_blank")
				.number-collection
				span.collection-name {{ collection.node.title }}
</template>

<script>
import axios from "axios";
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import _ from "lodash";

export default {
  props: {
    idsCollections: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      collections: []
    };
  },
  methods: {
    getRecommends() {
      let vm = this;
      axios
        .get("https://damp-stream-70537.herokuapp.com/")
        .then(res => {
          vm.collections = res.data.collections.collections.edges;
        })
        .catch(err => {
          console.log(err);
        });
    },
    checkId(id) {
      let exist = _.find(this.idsCollections, s => {
        return id.split("gid://shopify/Collection/")[1] == s;
      });
      if (exist) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.getRecommends();
  }
};
</script>
<style lang="sass">
@import 'bulma/sass/utilities/_all'
+touch
	.products
		grid-template-columns: repeat(2, 1fr)
+desktop
	.products
		grid-template-columns: repeat(3, 1fr)
.collection-name
	font-weight: bold
.collections
	padding: 20px
	display: flex
	align-items: center
	justify-content: space-evenly
	flex-wrap: wrap
.collection
	display: flex
	flex-direction: column
	align-content: center
	margin-bottom: 30px
	border-radius: 10px
	overflow: hidden
	box-shadow: 8px 8px 3px rgba(156, 156, 156, 0.4)
	&:nth-child(1)
		.number-collection
			&:after
				content: "#1"
	&:nth-child(2)
		.number-collection
			&:after
				content: "#2"
	&:nth-child(3)
		.number-collection
			&:after
				content: "#3"
	&:hover
		box-shadow: 10px 10px 3px rgba(156, 156, 156, 0.5)
.number-collection
	text-align: center
	padding: 10px 0
	background: #fff200
	color: #1a1a1a
	font-weight: bold
	font-size: 2em
.collection-name
	padding: 10px 20px
	background: #1a1a1a
	color: #fff200
</style>
